/** Keep only the origin. Referrer paths and queries may contain contact details or tokens. */
export function safeReferrerOrigin(value: unknown): string | null {
  if (typeof value !== 'string' || !value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:' ? url.origin : null;
  } catch {
    return null;
  }
}

/** A route path can be useful for analytics; query strings and fragments are not. */
export function safeTrackingPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return null;
  try {
    return new URL(value, 'https://intelgrader.com').pathname;
  } catch {
    return null;
  }
}

export function safeTrackingUrl(value: unknown): string | null {
  if (typeof value !== 'string' || !value) return null;
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:' ? `${url.origin}${url.pathname}` : null;
  } catch {
    return null;
  }
}
